<template>
  <OperationsDashboard mode="purchase" />
</template>
<script setup>
import OperationsDashboard from '@/components/module/smart/OperationsDashboard.vue';
</script>
